import React from "react";
import { Button } from "@mui/material";
import Role from "../../policies/Role";
import PoliciesHelper from "../../policies/PoliciesHelper";
import BadgeAssignationPopup from "./Popups/BadgeAssignationPopup/BadgeAssignationPopup";
import { AuthContext } from "../../context/AuthContext";
import { Link } from "react-router-dom";

class AssignBadgeButton extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isBadgeAssignationOpen: false,
    };
  }

  /**
   * Vérifie si l'utilisateur peut assigner des badges.
   *
   * Cette fonction regarde le rôle de l'utilisateur courant
   * et retourne true si celui-ci possède les permissions nécessaires.
   *
   * Rôles autorisés :
   * - Enseignant (Teacher)
   * - Administrateur (Admin)
   * - Contact administrateur (AdminContact)
   *
   * @returns {boolean} true si l'utilisateur peut assigner des badges, sinon false
   *
   * Philippe-Vu Beaulieu - 2026-04-16
   */
  canAssignBadges = () => {
    const role = this.context?.user?.role;
    const policiesHelper = new PoliciesHelper(role);
    if (policiesHelper.hasRole(Role.Teacher)) return true;
    if (policiesHelper.hasRole(Role.Admin)) return true;
    if (policiesHelper.hasRole(Role.AdminContact)) return true;
    return false;
  };
  static contextType = AuthContext;
  render() {
    const {
      sx = {},
      variant = "contained",
      color = "secondary",
      fullWidth = false,
      children = "Assigner",
    } = this.props;

    if (!this.canAssignBadges()) {
      return null;
    }

    return (
      <>
        <Button
          fullWidth={fullWidth}
          variant={variant}
          color={color}
          sx={{
            ...sx,
            backgroundColor: "#90EE90",
            color: "#1a1a1a",
            "&:hover": {
              backgroundColor: "#72d672",
            },
          }}
          component={Link}
          to="/assigner-badges"
        >
          {children}
        </Button>
      </>
    );
  }
}

export default AssignBadgeButton;
